import useEffectOnce from "hooks/useEffectOnce";
import { useState } from "react";
import { createAPI } from "services/api/api";

const ProfileChangePhoneVerify = ({ code, setCode, phone, setStep }) => {

  const api = createAPI();

  const [ticks, setTicks] = useState(30);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);

  const startTimer = () => {
    setIsResendDisabled(true)
    const timerId = setInterval(() => {
      setTicks((prevTick) => prevTick - 1);
    }, 1000);

    setTimeout(() => {
      clearInterval(timerId)
      setTicks(30);
      setIsResendDisabled(false)
    }, 30000);
  }

  const resendCode = () => {
    startTimer();

    api.post('/me/resend_code', {number: phone})
    .then((res) => console.log(res))
    .catch((e) => console.log('errof of resending code', e))
  }

  const submitVerifyCode = async () => {
    setIsResendDisabled(true);
    setIsSubmitDisabled(true);
    await api.post('/me/verify_number', {
      number: phone,
      code
    })
    .then(() => setStep('success'))
    .catch((e) => {
      console.log('error of sending digit code', e);
      setStep('fail')
    })
    .finally(() => {
      setIsResendDisabled(false);
      setIsSubmitDisabled(false);
    })
  }

  useEffectOnce(() => {
    startTimer();
  })

  return (
    <>
      <h2 className="modal-window__title">Verify Your Identity</h2>
      <form className="profile-change__form profile-change__form--code">
        <p className="profile-change__row">
          <label htmlFor="code">Enter the six digit code</label>
          <input
            type="number"
            id="code"
            placeholder="Code"
            onInput={(e) => {
              setCode(e.target.value)
            }}
            value={code}
          />
          <button
            className="profile-change__row-resend"
            disabled={isResendDisabled}
            onClick={(e) => {
              e.preventDefault();
              resendCode();
            }}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.3332 8.33333V5.83333C13.3332 3.99238 11.8408 2.5 9.99984 2.5C8.15889 2.5 6.6665 3.99238 6.6665 5.83333V8.33333M9.99984 11.6667V14.1667M4.1665 8.33333H15.8332V17.5H4.1665V8.33333Z"
                stroke="#AAABAB"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            Resend ({ticks} sec)
          </button>
        </p>
        <p className="profile-change__tip">
          We sent the verification code to: {phone}
        </p>
        <button
          type="button"
          className="profile-change__form-submit"
          onClick={submitVerifyCode}
          disabled={code.length < 6 || isSubmitDisabled}
        >
          Confirm
        </button>
      </form>
    </>
  );
};

export default ProfileChangePhoneVerify;
